// jQueryプラグイン
import 'jquery.easing';
/* -----------------------------------------------------
ページ内リンクのアニメーション
------------------------------------------------------- */
export function pageMoveAnkerFunc() {
  const detailWatchOffset = {
    pcLarge: 260,
    pc: 260,
    sp: 160,
  };

  const detailStandOffset = {
    pcLarge: 140,
    pc: 140,
    sp: -70,
  };

  const getDetailWatchOffset = () => {
    const windowWidth = window.innerWidth;

    if (windowWidth >= 1441) {
      return detailWatchOffset.pcLarge;
    }

    if (windowWidth >= 769) {
      return detailWatchOffset.pc / 1440 * windowWidth;
    }

    return detailWatchOffset.sp/ 750 * windowWidth;
  };

  const getDetailStandOffset = () => {
    const windowWidth = window.innerWidth;

    if (windowWidth >= 1441) {
      return detailStandOffset.pcLarge;
    }

    if (windowWidth >= 769) {
      return detailStandOffset.pc / 1440 * windowWidth;
    }

    return detailStandOffset.sp / 750 * windowWidth;
  };

  const getOffset = (id) => {
    const isSp = window.innerWidth <= 767;

    if (id === 'detailWatchWrap') {
      return getDetailWatchOffset();
    }

    if (id === 'detailStand') {
      return getDetailStandOffset();
    }

    return isSp ? -70 : 40;
  };

  $('a[href^="#"]:not(.notScroll)').each(function () {
    var pageUrl = location.href.split('#')[0];
    if (this.href.indexOf(pageUrl + '#') === 0) {
      var id = this.href.split('#')[1];
      $(this).on('click', function () {
        const $target = $('#' + id);
        if (!$target.length) return false;

        if (window.innerWidth <= 767 && $('.scroll').length) {
          const scrollContainer = $('.scroll');
          const scrollElement = scrollContainer[0];
          const getPosition = () => {
            return $target[0].getBoundingClientRect().top
              - scrollElement.getBoundingClientRect().top
              + scrollElement.scrollTop
              - getOffset(id);
          };

          scrollContainer.stop(true).animate({
            scrollTop: getPosition()
          }, 1000, 'easeInOutQuart', function () {
            // 固定ヘッダーの切り替えでレイアウトが変わった場合も最終位置を合わせる。
            scrollElement.scrollTop = getPosition();
          });
        } else {
          const scrollElement = document.scrollingElement || document.documentElement;
          const getPosition = () => $target.offset().top - getOffset(id);

          $(scrollElement).stop(true).animate({
            scrollTop: getPosition()
          }, 1000, 'easeInOutQuart', function () {
            // 固定ヘッダーの切り替えでレイアウトが変わった場合も最終位置を合わせる。
            scrollElement.scrollTop = getPosition();
          });
        }

        return false;
      });
    }
  });
}
